import { RECENT_STICKER_KEY } from "./constants";
import Storage from "./Storage";

class RecentStickerStorage extends Storage {

	constructor() {
		super(RECENT_STICKER_KEY);
		this._stickerRecent = JSON.parse(this._storage) || []
	}

	get stickerRecent() {
		return this._stickerRecent;
	}

	set stickerRecent(s) {
		this._stickerRecent = s;
	}

	save() {
		this._storage = JSON.stringify(this._stickerRecent);
		super.save()
	}
}

export default RecentStickerStorage;
export const recentStickers = new RecentStickerStorage();
